<div class="tag-editor-custom-container" [class.has-tags]="insertedTags.length > 0">
  <!-- Sidebar with inserted tags -->
  @if (insertedTags.length > 0) {
    <div class="tag-sidebar-container">
      <p-listbox
        #tagListbox
        [options]="insertedTagsArray"
        [(ngModel)]="selectedTag"
        [ngModelOptions]="{ standalone: true }"
        [dataKey]="'id'"
        optionLabel="label"
        [multiple]="false"
        (onChange)="onTagClick($event.value)"
        class="compact-tag-listbox"
      >
        <ng-template pTemplate="header">
          <div class="listbox-header">
            <i class="pi pi-tags"></i>
            <span>{{ 'TAG_EDITOR.INSERTED_TAGS' | transloco }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-tag>
          <div class="compact-tag-item" [style.border-left]="'3px solid #' + tag.color" [title]="tag.label">
            <div class="tag-content">
              <div class="tag-color-indicator" [style.background-color]="'#' + tag.color"></div>
              <i class="pi pi-tag tag-icon" [style.color]="'#' + tag.color"></i>
              <span class="tag-text" [title]="tag.label">{{ tag.label }}</span>
            </div>
            <button
              type="button"
              class="tag-remove-btn"
              (click)="removeTag(tag.id); $event.preventDefault(); $event.stopPropagation()"
              [title]="'TAG_EDITOR.REMOVE_TAG' | transloco"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </ng-template>
      </p-listbox>
    </div>
  }

  <!-- Editor column -->
  <div class="editor-column">
    <!-- Custom Toolbar -->
    <div class="editor-toolbar">
      <div class="toolbar-group">
        <!-- Bold -->
        <button
          type="button"
          class="toolbar-button"
          [class.active]="formattingState.isBold"
          (mousedown)="$event.preventDefault()"
          (click)="applyBold()"
          [title]="'TAG_EDITOR.TOOLBAR.BOLD' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.BOLD' | transloco"
        >
          <strong>B</strong>
        </button>

        <!-- Italic -->
        <button
          type="button"
          class="toolbar-button"
          [class.active]="formattingState.isItalic"
          (mousedown)="$event.preventDefault()"
          (click)="applyItalic()"
          [title]="'TAG_EDITOR.TOOLBAR.ITALIC' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.ITALIC' | transloco"
        >
          <em>I</em>
        </button>

        <!-- Underline -->
        <button
          type="button"
          class="toolbar-button"
          [class.active]="formattingState.isUnderline"
          (mousedown)="$event.preventDefault()"
          (click)="applyUnderline()"
          [title]="'TAG_EDITOR.TOOLBAR.UNDERLINE' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.UNDERLINE' | transloco"
        >
          <u>U</u>
        </button>
      </div>

      <div class="toolbar-separator"></div>

      <div class="toolbar-group">
        <!-- Ordered List -->
        <button
          type="button"
          class="toolbar-button"
          [class.active]="formattingState.isOrderedList"
          (mousedown)="$event.preventDefault()"
          (click)="insertOrderedList()"
          [title]="'TAG_EDITOR.TOOLBAR.ORDERED_LIST' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.ORDERED_LIST' | transloco"
        >
          1.
        </button>

        <!-- Unordered List -->
        <button
          type="button"
          class="toolbar-button"
          [class.active]="formattingState.isUnorderedList"
          (mousedown)="$event.preventDefault()"
          (click)="insertUnorderedList()"
          [title]="'TAG_EDITOR.TOOLBAR.BULLET_LIST' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.BULLET_LIST' | transloco"
        >
          •
        </button>
      </div>

      <div class="toolbar-separator"></div>

      <div class="toolbar-group">
        <!-- Link -->
        <button
          type="button"
          class="toolbar-button"
          (mousedown)="$event.preventDefault()"
          (click)="insertLink()"
          [title]="'TAG_EDITOR.TOOLBAR.INSERT_LINK' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.INSERT_LINK' | transloco"
        >
          🔗
        </button>

        <!-- Remove Format -->
        <button
          type="button"
          class="toolbar-button"
          (mousedown)="$event.preventDefault()"
          (click)="removeFormat()"
          [title]="'TAG_EDITOR.TOOLBAR.REMOVE_FORMATTING' | transloco"
          [attr.aria-label]="'TAG_EDITOR.TOOLBAR.REMOVE_FORMATTING' | transloco"
        >
          ✕
        </button>
      </div>

      <div class="toolbar-separator"></div>

      <div class="toolbar-group">
        <!-- Insert Tag -->
        <button
          type="button"
          class="toolbar-button tag-button"
          [class.active]="isTextSelected"
          (mousedown)="$event.preventDefault()"
          (click)="openTagSelector()"
          [title]="'TAG_EDITOR.INSERT_TAG_TOOLTIP' | transloco"
          [attr.aria-label]="'TAG_EDITOR.INSERT_TAG' | transloco"
        >
          <i class="pi pi-tag"></i>
          <span class="button-label">{{ 'TAG_EDITOR.INSERT_TAG' | transloco }}</span>
        </button>

        <!-- Debug HTML -->
        @if (debug) {
          <button
            type="button"
            class="toolbar-button"
            (click)="copyEditorHtmlToClipboard()"
            [title]="'TAG_EDITOR.DEBUG_HTML_TOOLTIP' | transloco"
            [attr.aria-label]="'TAG_EDITOR.DEBUG_HTML' | transloco"
          >
            <i class="pi pi-code"></i>
            <span class="button-label">{{ 'TAG_EDITOR.DEBUG_HTML' | transloco }}</span>
          </button>
        }
      </div>
    </div>

    <!-- Content Editor (contenteditable) -->
    <div
      #editorContent
      class="editor-content"
      [attr.contenteditable]="!disabled"
      [attr.spellcheck]="false"
      [title]="placeholder || ('TAG_EDITOR.PLACEHOLDER' | transloco)"
    ></div>
  </div>
</div>

<!-- Tag Selector Modal -->
@if (showTagSelector) {
  <div class="tag-selector-overlay" (click)="closeTagSelector()">
    <div class="tag-selector-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'EVENT_EDITOR.SR_EVENT.INSERT_TAG' | transloco }}</h3>
        <div class="modal-header-actions">
          @if (clientId) {
            <ion-button fill="clear" (click)="openIpJournalInNewTab()" [title]="'TAG_EDITOR.GO_TO_IP_JOURNAL' | transloco">
              <ion-icon name="journal-outline"></ion-icon>
            </ion-button>
          }
          @if (useInternalLoadingForDisplay && clientId) {
            <ion-button fill="clear" (click)="refreshTreeNodes()" [title]="'TAG_EDITOR.REFRESH_TAGS' | transloco">
              <ion-icon name="refresh"></ion-icon>
            </ion-button>
          }
          <ion-button fill="clear" (click)="closeTagSelector()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </div>
      </div>
      <div class="modal-content">
        @if (!treeNodes || treeNodes.length === 0) {
          <div class="empty-state">
            <ion-icon name="folder-open-outline" class="empty-icon"></ion-icon>
            <h4>{{ 'TAG_EDITOR.NO_RECORDS_TITLE' | transloco }}</h4>
            <p>
              {{ 'TAG_EDITOR.NO_RECORDS_MESSAGE' | transloco }}
              <a class="ip-journal-link" [href]="getIpJournalUrl()" target="_blank" rel="noopener noreferrer">
                {{ 'TAG_EDITOR.NO_RECORDS_LINK' | transloco }}
              </a>
              .
            </p>
          </div>
        } @else {
          <p-tree
            [value]="treeNodes"
            [filter]="true"
            [filterPlaceholder]="'TAG_EDITOR.SEARCH_TAGS' | transloco"
            selectionMode="single"
            (onNodeSelect)="onTreeNodeSelect($event)"
            (onNodeUnselect)="onTreeNodeUnselect($event)"
            [metaKeySelection]="false"
          ></p-tree>
        }
      </div>
    </div>
  </div>
}
